import React, { ReactElement } from 'react'
import Icon, { IconName } from '@dustin-web/microsite-components/src/icon'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import type {
  SuggestionsQuery,
  RecentSearchesQuery,
} from '@dustin-web/microsite-baselayout/src/components/header/types'
import { TicketLink } from '@dustin-web/product-components/src/ticket-link'

type SuggestionsProps = {
  recentSearches?: RecentSearchesQuery
  suggestions?: SuggestionsQuery
  searchPhrase: string
  header: ReactElement
  icon: IconName
  clearRecentSearchHandler?: (title?: string | null) => void
}

const Suggestions = ({
  suggestions,
  recentSearches,
  searchPhrase,
  header,
  icon,
  clearRecentSearchHandler,
}: SuggestionsProps) => {
  const { translate } = useTranslations()
  const items = suggestions || recentSearches

  return (
    <>
      {header}
      <ul className="c-header__autocomplete-mini-list">
        {items?.slice(0, 5).map((item, i) => (
          <li className="c-header__autocomplete-mini-item" key={i}>
            <TicketLink
              url={`/${translate('SearchPath')}${item?.url?.replace('//', '/') ?? ''}`}
              ticket={suggestions ? (suggestions[i]?.ticket as string) : ''}
              className="c-header__autocomplete-mini-link"
              onClickCallBack={() =>
                DigitalData.pushSearchDropdownInteraction(
                  item?.title ?? '',
                  searchPhrase,
                  'autocomplete_search_term'
                )
              }>
              <Icon className="c-header__autocomplete-mini-icon" name={icon} />
              {item?.title?.includes(searchPhrase.toLowerCase()) ? (
                <span className="c-header__autocomplete-mini-text">
                  {searchPhrase.toLowerCase()}
                  <span className="u-fw-bold">
                    {item?.title?.replace(searchPhrase.toLowerCase(), '')}
                  </span>
                </span>
              ) : (
                <span className="c-header__autocomplete-mini-text">{item?.title}</span>
              )}
              {clearRecentSearchHandler && item?.title && (
                <button
                  type="button"
                  className="c-header__autocomplete-mini-btn u-decoration-underline u-color-black"
                  aria-label="clear all"
                  onClick={e => {
                    e.preventDefault()
                    clearRecentSearchHandler(item?.title)
                  }}>
                  <Icon className="i-16" name={'close'} />
                </button>
              )}
            </TicketLink>
          </li>
        ))}
      </ul >
    </>
  )
}

export default Suggestions
